/**
 * @file 插件入口
 * @version
 * @author pankzou
 * @date 2022-02-18
 * @lastModified
 * @lastModifiedDate
 */
import modal from './modal'

export default {
	install(Vue) {
		// 提示框对象
		Vue.prototype.$modal = modal
	}
}
